module.exports = __webpack_public_path__ + "img/Jamendo.f6d5c435.png";